module.exports = __webpack_public_path__ + "static/media/credits-icon-back.bf5aebbe.png";